import React, { useEffect, useState } from 'react';
import cleanObject from 'src/utils/cleanObject';
import AdminDivisionService from 'src/services/AdminDivision.service';
import BrandAutocomplete, { createOptionsFromArr } from '.';

function CircleAutoComplete({
  onChange,
  value,
  name,
  label,
  noLabel = false,
  multiple = false,
  filter = {},
  disabled = false
}) {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchCircles = async () => {
    setLoading(true);
    try {
      const validFilter = cleanObject(filter);
      const { data } = await AdminDivisionService.get({
        ...validFilter,
        type: 'CIRCLE'
      });
      // console.log("Zone fetching Success",data);
      setOptions(data || []);
    } catch (error) {
      console.error('Zone fetching Error', error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCircles();
  }, [Object.values(filter).join('')]);
  return (
    <BrandAutocomplete
      label={label ?? 'Parent Zone'}
      noLabel={noLabel}
      placeholder={loading ? 'Loading....' : 'Select parent zone...'}
      onChange={onChange}
      value={value}
      multiple={multiple}
      name={name ?? 'Zone'}
      options={createOptionsFromArr(options, 'name', 'id')}
      disabled={disabled}
    />
  );
}

export default CircleAutoComplete;
